
import { useMemo } from 'react';
import { getSectionFromKey } from './addressLabels';
import { useAllFieldKeys } from '../../FormEngine/FormFieldsContext';

const ROLE_TOKENS = {
  country: 'country',
  zip: 'zip',
  state: 'state',
  county: 'county',
  city: 'city',
};

export function getAddressKeys(fieldKey, allKeys = []) {
  const empty = {
    countryKey: null,
    zipKey: null,
    stateKey: null,
    countyKey: null,
    cityKey: null,
  };

  if (!fieldKey) return empty;

  const section = getSectionFromKey(fieldKey);
  if (!section) return empty;

  const result = { ...empty };
  const keys = Array.isArray(allKeys) && allKeys.length > 0 ? allKeys : [];

  keys.forEach((k) => {
    if (!k) return;
    const keySection = getSectionFromKey(k);
    if (keySection !== section) return;

    const lower = String(k).toLowerCase();
    Object.entries(ROLE_TOKENS).forEach(([role, token]) => {
      if (result[`${role}Key`]) return;
      if (lower.includes(`_${token}_`) || lower.includes(`_${token}`) || lower.endsWith(token)) {
        result[`${role}Key`] = k;
      }
    });
  });

  return result;
}

export function useAddressSiblings(fieldKey) {
  const allFieldKeys = useAllFieldKeys();
  return useMemo(() => getAddressKeys(fieldKey, allFieldKeys), [fieldKey, allFieldKeys]);
}
